<template>
  <div class="pageess">
    <div class="pd-30">
      <div class="flex-column-start">
        <div class="newstitle" v-html="showcontent(newslist.title)"></div>
        <div class="flex-row-start1 mgt-10">
          <div class="name">安徽省网商协会</div>
          <div class="time norgin">{{ newslist.releaseTime }}</div>
        </div>
        <div class="flex-row-start1 mgt-10">
          <div class="autor">作者：{{ newslist.author ? newslist.author:'暂无' }}</div>
          <div class="autor norgin">来源：{{ newslist.origin ? newslist.origin : '暂无'}}</div>
        </div>
        <div class="cont  mgt-10" v-html="showcontent(newslist.content)"></div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import { newslistt } from "@apis/apis";
import Swiper from "swiper";
import { showcontent } from "@utils/method.js";
import "swiper/dist/css/swiper.css";
export default {
  loading: true,
  data() {
    return {
      newslist: "",
      id: "",
    };
  },
  watch: {},
  created() {
    this.id = this.$route.query.id;
    this.getnew();
    // console.log(this.$route.query);
  },
  activated() {},
  mounted() {},
  methods: {
    showcontent,
    getnew() {
      const id = this.id;
      this.$ajaxGet(`${newslistt}/${id}`).then((res) => {
        res.data.data.releaseTime = res.data.data.releaseTime.split(" ")[0];
        res.data.data.author = showcontent(res.data.data.author);
        res.data.data.origin = showcontent(res.data.data.origin);
        this.newslist = res.data.data;
      });
    },

    //防止刷新后父节点的值会改变
  },
};
</script>

<style lang="less" scoped>
.pageess {
  background-color: #fff;
  .pd-30 {
    padding: 15px;
  }
  .newstitle {
    text-align: left;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #333333;
  }
  .name {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4e6181;
  }
  .time {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
  .autor {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
  .norgin {
    margin-left: 15px;
  }
  .mgt-10 {
    margin-top: 10px;
  }
  .cont {
    height: 100%;
    margin-bottom: 20px;
    text-align: left;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
  /deep/img{
    width: 100%;
   object-fit: contain;
   text-align: center;
}
}
</style>
